import { PropResolverDecorator } from '@get-bridge/learn-legacy-packages.bridge-async-props';
import buildAsyncProps from './buildAsyncProps';
import { productEnabled } from '@get-bridge/learn-legacy-shared/dist/utils/accountConfig';
import LtiPlacementStore from '@get-bridge/learn-legacy-shared/dist/stores/LtiPlacementStore';
import AtlasWrapper from './AtlasWrapper';

export default PropResolverDecorator({
  type: AtlasWrapper,
  asyncProps: buildAsyncProps(productEnabled, LtiPlacementStore),
});



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/GlobalNav.js